import React from 'react';
import ItemList from '../components/ItemList';

function Encargos() {

  const menusList2 = [
    { name: 'Pastela', description: 'De pollo y almendras', price: '18,00€', img: "https://imag.bonviveur.com/pastela-de-pollo-marroqui.jpg" },
    { name: 'Tajín de Carne', description: 'Carne guisada con especias', price: '18,00€', img: "https://www.marialunarillos.com/blog/wp-content/uploads/2014/05/tajin-marroqui.jpg" },
    { name: 'Cuscús', description: 'Con verduras y acompañamientos', price: '12,00€', img: "https://www.melonsinjamon.com/wp-content/uploads/2022/04/receta-cuscus-rapido.jpg" },
    { name: 'Sushi', description: 'Pieza Surimi, Salmón, Kebab', price: '1€ Pieza', img: "https://th.bing.com/th/id/R.a4d8f90c3de286bc75bfdf5ee75248be?rik=YHnsBv2cUuHC9w&pid=ImgRaw&r=0" },
  ];


  return (
    <div id="tacos" className="container mx-auto mt-8 px-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Tacos Gratinados</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {menusList2.map((item) => (
          <ItemList
            key={item.key}
            name={item.name}
            description={item.description}
            price={item.price}
            img={item.img}
            menuPrice={item.menuPrice}
            menuIncludes={item.menuIncludes}
          />
        ))}
      </div>
    </div>
  );
}

export default Encargos;
